module.exports = __webpack_public_path__ + "83c022a1bf2c7bc95c5c0aef34e5116a.png";